'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _reactRouter = require('react-router');

var _constants = require('../../constants');

var _util = require('../../utils/util');

var _common = require('../common');

var _OrganizationListSidebar = require('./OrganizationListSidebar');

var _OrganizationListSidebar2 = _interopRequireDefault(_OrganizationListSidebar);

var _Columns = require('./Columns');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var MODEL_TYPES = _constants.AppConstants.MODEL_TYPES;
var OrganizationListPage = (_dec = (0, _mobxReact.inject)('CaseStore', 'Clients', 'FunderStore', 'SessionStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(OrganizationListPage, _Component);

  function OrganizationListPage(props) {
    _classCallCheck(this, OrganizationListPage);

    var _this = _possibleConstructorReturn(this, (OrganizationListPage.__proto__ || Object.getPrototypeOf(OrganizationListPage)).call(this, props));

    _this.isMedical = props.route.isMedical;
    _this.pageStore = props.UiStore.organizationListPage;
    return _this;
  }

  _createClass(OrganizationListPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var query = this.props.location.query,
          ordering = query.ordering && (0, _util.unformatSortingParams)(query.ordering),
          filters = (0, _omit3.default)(query, ['ordering', 'search']),
          defaultOrdering = [{ desc: false, id: 'name' }];

      // limit types filtered for backwards compatibility
      if (this.isMedical) {
        filters.type = MODEL_TYPES.medicalFacility.key;
      } else {
        filters.type = MODEL_TYPES.lawFirm.key;
      }

      this.pageStore.ordering = ordering || defaultOrdering;
      this.pageStore.filters = filters;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleFilterChange({ onInitialPageLoad: true });
    }
  }, {
    key: 'insertColumn',
    value: function insertColumn(column) {
      var FunderStore = this.props.FunderStore;

      return column.insertIf ? column.insertIf(FunderStore) : true;
    }
  }, {
    key: 'changeFilters',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var onQueryReset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.pageStore.loading = true;
                _context.next = 3;
                return this.handleFilterChange({ onQueryReset: onQueryReset });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function changeFilters() {
        return _ref.apply(this, arguments);
      }

      return changeFilters;
    }()
  }, {
    key: 'handleFilterChange',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref3$onInitialPageLo = _ref3.onInitialPageLoad,
            onInitialPageLoad = _ref3$onInitialPageLo === undefined ? false : _ref3$onInitialPageLo,
            _ref3$onQueryReset = _ref3.onQueryReset,
            onQueryReset = _ref3$onQueryReset === undefined ? false : _ref3$onQueryReset;

        var _props, location, Clients, pathname, query, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props = this.props, location = _props.location, Clients = _props.Clients, pathname = location.pathname, query = this.pageStore.query;


                _reactRouter.browserHistory.push({ pathname: pathname, query: query });
                _context2.next = 4;
                return Clients.organizations.list({ params: query });

              case 4:
                data = _context2.sent;


                this.trackFilterChangeEvent(onInitialPageLoad, onQueryReset);

                this.pageStore.tableData = data.results;
                this.pageStore.nextPageURL = data.next;
                this.pageStore.loading = false;

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleFilterChange() {
        return _ref2.apply(this, arguments);
      }

      return handleFilterChange;
    }()
  }, {
    key: 'trackFilterChangeEvent',
    value: function trackFilterChangeEvent(onInitialPageLoad, onQueryReset) {
      var SessionStore = this.props.SessionStore,
          eventName = 'ORGANIZATION_LIST_QUERY_CHANGE',
          eventData = _extends({
        on_initial_page_load: onInitialPageLoad,
        on_query_reset: onQueryReset
      }, this.pageStore.queryToLog);

      SessionStore.trackEvent(eventName, eventData);
    }
  }, {
    key: 'onLoadMoreClick',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var Clients, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                Clients = this.props.Clients;


                this.pageStore.loading = true;
                _context3.next = 4;
                return Clients.organizations.loadMore(this.pageStore.nextPageURL);

              case 4:
                data = _context3.sent;

                this.pageStore.tableData = this.pageStore.tableData.concat(data.results);
                this.pageStore.nextPageURL = data.next;
                this.pageStore.loading = false;

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onLoadMoreClick() {
        return _ref4.apply(this, arguments);
      }

      return onLoadMoreClick;
    }()
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _common.Page,
        { name: 'firms', type: 'list', hasSidebar: true },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Organizations' }),
        _react2.default.createElement(
          _common.Page.Sidebar,
          null,
          _react2.default.createElement(_OrganizationListSidebar2.default, {
            changeFilters: this.changeFilters,
            isMedical: this.isMedical
          })
        ),
        _react2.default.createElement(
          _common.Page.Content,
          null,
          _react2.default.createElement(_common.BaseList, {
            columns: this.tableColumns,
            handleSort: this.changeFilters,
            onLoadMoreClick: this.onLoadMoreClick,
            pageStore: this.pageStore,
            title: this.isMedical ? 'Facilities' : 'Law Firms',
            entityType: 'firms'
          })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'tableColumns',
    get: function get() {
      var _this2 = this;

      var columns = _Columns.ORGANIZATION_COLUMNS.filter(function (column) {
        return _this2.insertColumn(column);
      });

      if (this.isMedical) {
        return columns.filter(function (column) {
          return !column.isLegalOnly;
        });
      }

      return columns;
    }
  }]);

  return OrganizationListPage;
}(_react.Component), _class3.propTypes = {
  CaseStore: _propTypes2.default.object,
  FunderStore: _propTypes2.default.object,
  location: _propTypes2.default.object,
  route: _propTypes2.default.object,
  SessionStore: _propTypes2.default.object,
  UiStore: _propTypes2.default.object
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'changeFilters', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'changeFilters'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleFilterChange', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handleFilterChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onLoadMoreClick', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onLoadMoreClick'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = OrganizationListPage;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(MODEL_TYPES, 'MODEL_TYPES', '/app/src/components/page-organization-list/OrganizationListPage.js');
  reactHotLoader.register(OrganizationListPage, 'OrganizationListPage', '/app/src/components/page-organization-list/OrganizationListPage.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-organization-list/OrganizationListPage.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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